import React, { useState } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
// import AddRowTable from '../../Components/Table/AddRowTable';
import toast from 'react-hot-toast';
import dayjs from 'dayjs';

import { 
    Layout,
    Col, 
    Row,
    Button,
    // Modal,
    Checkbox,
    Upload,
    Form,
    Select,
    Input,
    DatePicker,
    Divider,
    InputNumber,
    AutoComplete,
    Modal,
    Space,
    Table,
    Switch,
} from 'antd'
import {
    ExclamationCircleFilled, 
    InboxOutlined, 
    DeleteOutlined, 
    ProductOutlined,
} from '@ant-design/icons';
// import { isAnyRequiredFieldEmpty } from '../../Utils/Common';
import { useNavigate, useParams } from 'react-router-dom';
import { usePostRequest } from '../../hooks/usePostRequest'
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { formatAmount, formatDate } from '../../Utils/Common';
import { SeeAttachment } from '../../Components/SeeAttachment';

// const { Search } = Input;
const { Option } = Select;
const { Item } = Form;
const { TextArea } = Input;
const { RangePicker } = DatePicker;
const { confirm } = Modal;

const AddEditContract = () => {
    const [addParkingForm] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const { id, type } = useParams();
    const navigate = useNavigate()
    const currentDate = new Date().toISOString().split('T')[0];
    const [parkingPayables, setParkingPayables] = useState({
        with_parking_security_deposit: false,
        with_parking_advance_rental: false,
    });
        
    const [startContractData, setStartContractDate] = useState({
        start_date: currentDate
    })
    const [startParkingContractData, setParkingStartContractDate] = useState({
        start_date: currentDate
    })
    const [isDisabled, setIsDisabled] = useState(true);

    const [leaseTerm, setLeaseTerm] = useState({
        parking: 0,
        unit: 0,
    })
    const [leaseType, setLeaseType] = useState({
        parking: 'year',
        unit:'year',
    })
    const [attachmentsData, setAttachmentsData] = useState([]);
    const [newAttachment, setNewAttachment] = useState([]);

    const [choosenId, setChoosenId] = useState([]);

    const [propertyParkingData, setPropertyParkingData] = useState([]);
    const [tenantData, setTenantData] = useState([])
    const [options, setOptions] = useState([])
    const [parkingRow, setParkingRow] = useState([
        {
            property_id: '',
            parking_unit_ids: '',
            parking_rental_rates: '',
            management_fee: '',
            agent_fee: '',
            is_managed: false,
            manage_type: false,
        }
    ]);
    
    const [renterId, setRenterId] = useState('')
    const [contractDate, setContractDate] = useState([])
    const { callPost, data, loading } = usePostRequest(()=>{
        addParkingForm.resetFields();
    });

    const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;


    const values = Form.useWatch([], addParkingForm);

    React.useEffect(() => {
        addParkingForm.validateFields({
        validateOnly: true,
        }).then(() => {
        setIsDisabled(false);
        },
        () => {
        setIsDisabled(true);
        },
        );
    }, [values, addParkingForm]);

    React.useEffect(() => {
        if (data) {
            navigate('/parking-contract');
        }
    }, [data, navigate]);

    React.useEffect(() => {
        if(type === 'edit'){
            fetchEditParkingData();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        type
    ]);

    React.useEffect(() => {
        if(type === "edit"){
            fetchParkingProperty();
        } else {
            fetchPropertyParkingData();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type]);

    React.useEffect(() => {
        fetchTenantData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const columns2 = [
        {
            title: 'Date Added',
            dataIndex: 'added_on',
            key: 'added_on',
            width: '30%',
            render: (amount) => formatDate(amount),
        },
        {
            title: 'Attachments',
            dataIndex: 'link',
            key: 'link',
        },
    ]; 

    const handleAddRow = () => {
        const newRow = {
            property_id: '',
            parking_unit_ids: '',
            parking_rental_rates: '',
            management_fee: '',
            agent_fee: '',
            is_managed: false,
            manage_type: false,
        };

        setParkingRow(prev => [...prev, newRow]);
    };
    
    const handleDeleteRow = (rowId) => {
        const newData = [...parkingRow];
        newData.splice(rowId, 1); 
        setParkingRow(() => newData)
    };


    const fileUrlFormat = (files) => {
        if(files){
          return files?.map(file => ({
            uid: file.id,
            id: file.id,
            name: file.file_name,
            status: "done",
            url: file.file_url,
            fileType: file.file_type
          }));
        }
    };

    async function fetchEditParkingData() {
        setIsLoading(true)
        const response = await UseGetRequest("tenant_parkings/get", {tenant_parking_id: id});
        if (response?.data) {
            const tenant_data = response?.data?.data[0]
            setRenterId(tenant_data?.renter_id)  
            let attachment = tenant_data?.attachments?.map((file) => ({
                ...file,
                link: (
                    <SeeAttachment
                    attachments={[
                        { file_url: file.file_url, file_name: file.file_name },
                    ]}
                    />
                ),
                })) 
            
            const parking_list = await fetchParkingUnit();

            let parking_details = tenant_data?.details?.map((file) => ({
                ...file,
                property_id: file.property_id,
                parking_unit_ids: file.parking_unit_id,
                parking_rental_rates: file.parking_rental_rate,
                parking_list: parking_list || [],
                is_managed: file.is_managed === '1' ? true : false,
                manage_type: file.manage_type === 'percentage' ? true : false,
            })) 

            setParkingRow(parking_details)
            setAttachmentsData(fileUrlFormat(tenant_data?.attachments))
            setNewAttachment(attachment)
            addParkingForm.setFieldsValue({
                business_address: tenant_data.business_address,
                business_name: tenant_data.business_name,
                business_nature: tenant_data.business_nature,
                contact_no: tenant_data.contact_no,
                parking_contract_date: [
                    tenant_data.contract_sign_date ? dayjs(tenant_data.contract_sign_date, 'YYYY/MM/DD') : undefined,
                    tenant_data.contract_end_date ? dayjs(tenant_data.contract_end_date, 'YYYY/MM/DD') : undefined
                ],
                parking_lease_term: tenant_data.lease_term,
                parking_lease_type: tenant_data.lease_type,
                property: tenant_data.property_name,
                remarks: tenant_data.remarks,
                renter_email: tenant_data.renter_email,
                tin: tenant_data.tin,
                trade_name: tenant_data.trade_name,
                
            });

            setLeaseTerm((prev) => ({
                ...prev,
                parking: tenant_data.lease_term
            }))
            setLeaseType((prev) => ({
                ...prev,
                parking: tenant_data.lease_type
            }))
            setStartContractDate(tenant_data.contract_sign_date)
        } else {
            setRenterId('')  
            setAttachmentsData([])
            setParkingRow([
                {
                    property_id: '',
                    parking_unit_ids: '',
                    parking_rental_rates: ''
                }
            ])
            setNewAttachment([])
            setLeaseTerm({
                parking: '',
                unit:'',
            })
            setLeaseType({
                parking: 'year',
                unit:'year',
            })
            setStartContractDate({
                start_date: currentDate
            })
        }
        setIsLoading(false)
    }

    const handleParkingUnit = (e, recordKey, fieldName, parkingLists, dataRow) => {
        const updatedDataSource = parkingRow.map((item, index) => {
            if (index === recordKey) {
                if(fieldName === 'property_id'){
                    const parking_data = propertyParkingData.filter(data => data.id === e);
                    return { ...item, parking_list: parking_data[0].parking_units, [fieldName]: e, parking_unit_ids: '' };
                } else if(fieldName === 'parking_unit_ids'){
                    const parking = parkingLists.filter(data => data.id === e);
                    setChoosenId((prev) => {
                        const newArr = [...prev];
                        const existingIndex = newArr.findIndex((item) => item.index === recordKey);
                    
                        if (existingIndex !== -1) {
                            newArr[existingIndex] = { id: e, index: recordKey }; // Update existing object
                        } else {
                            newArr.push({ id: e, index: recordKey }); // Add new object
                        }
                    
                        return newArr;
                    });
                    
                      
                    return { ...item, [fieldName]: e, parking_rental_rates: parking[0].unit_price};
                } else if(fieldName === 'parking_advance_rental_months'){
                    return { ...item, [fieldName]: e, parking_advance_rental_amount: e *  parseFloat(dataRow?.parking_rental_rates || 0)};
                } else if(fieldName === 'parking_rental_rates'){
                    return { ...item, [fieldName]: e, parking_advance_rental_amount: e *  parseFloat(dataRow?.parking_advance_rental_months || 0)};
                } else {
                    return { ...item, [fieldName]: e };
                }
            }
            return item;
        });
        setParkingRow(updatedDataSource);
    };

    async function fetchPropertyParkingData() {

        const response = await UseGetRequest("properties/get_for_parking_contract", {property_id: ''});
        if (response?.data) {
          setPropertyParkingData(response?.data?.data);
        } else {
          setPropertyParkingData([])
        }
    
    }

    async function fetchParkingProperty() {

        const response = await UseGetRequest("properties/get", {property_id: ''});
        if (response?.data) {
          setPropertyParkingData(response?.data?.data);
        } else {
          setPropertyParkingData([])
        }
    
    }

    async function fetchParkingUnit() {
        try {
            const response = await UseGetRequest("parking_units/get", { property_id: '' });
            return response.data.data;
        } catch (error) {
            return []; // Return an empty array on error to avoid breaking the code.
        }
    }

    const handleSaveValidation = () => {
        var isValid = false;
    
        if(parkingPayables.with_parking_advance_rental){
            isValid = isDisabled || parkingRow.some(row => 
                !row.property_id || 
                !row.parking_unit_ids || 
                !row.parking_rental_rates ||
                !row.parking_advance_rental_months
            );
        } else{
            isValid = isDisabled || parkingRow.some(row => 
                !row.property_id || 
                !row.parking_unit_ids || 
                !row.parking_rental_rates
            );
        }
       
    
        return isValid;
    };

    async function fetchTenantData() {
        const response = await UseGetRequest("tenants/get_active_renter",);
        if (response?.data) {
          setTenantData(response?.data?.data);
        } else {
          setTenantData([])
        }
    }

    const handleAddTenant = () => {
        
        addParkingForm.validateFields().then(values => {
            const resetData = {
                business_address: values.business_address || '',
                business_name: values.business_name || '',
                business_nature: values.business_nature || '',
                contact_no: values.contact_no || '',
                contract_sign_date: values.parking_contract_date[0].format("YYYY-MM-DD") || '',
                contract_end_date: values.parking_contract_date[1].format("YYYY-MM-DD") || '',
                lease_type: values.parking_lease_type || '',
                lease_term: values.parking_lease_term || '',
                remarks: values.remarks || '',
                rental_unit_id: values.rental_unit_id || '',
                renter_email: values.renter_email || '',
                space_rental_rate: values.space_rental_rate || '',
                tin: values.tin || '',
                trade_name: values.trade_name || '',
        

                with_parking_advance_rental: parkingPayables.with_parking_advance_rental, 
                with_parking_security_deposit: parkingPayables.with_parking_security_deposit, 
                // parking_detail_ids: parkingRow.map((item)=>item.id),

                ...(parkingPayables.with_parking_advance_rental &&
                {
                    parking_advance_rental_amounts: parkingRow.map((item)=>item.parking_advance_rental_amount),
                    parking_advance_rental_months: parkingRow.map((item)=>item.parking_advance_rental_months),
                }
                ),
                ...(parkingPayables.with_parking_security_deposit &&
                {
                    parking_security_deposit_amounts: parkingRow.map((item)=>item.parking_security_deposit_amount),
                }
                ),      
            };

            const file = attachmentsData.map((file) => {
                return file.originFileObj;
            });

            if (renterId) {
                resetData.renter_id = renterId;
            }            

            resetData.parking_unit_ids = parkingRow.map((data)=> data.parking_unit_ids)
            resetData.parking_rental_rates = parkingRow.map((data)=> data.parking_rental_rates)
            resetData.parking_is_managed = parkingRow.map((data)=> data.is_managed)
            resetData.parking_management_fees = parkingRow.map((data)=> data.is_managed ? data.management_fee : '')
            resetData.parking_agent_fees = parkingRow.map((data)=> data.agent_fee)
            resetData.parking_manage_types = parkingRow.map((data)=> data.is_managed ? data.manage_type ? 'percentage' : 'fixed' : '')
           
            var finalValues = Object.entries({
                ...resetData, 
                attachments: file
            }).map(([key, value]) => ({
                key,
                value,
            }));

            callPost(
                "tenant_parkings/create", 
                finalValues,
                true,
            );
        }).catch(errorInfo => {
          toast.error('Validation Failed:', errorInfo);
        });
    };

    const handleEditTenant = () => {
        
        addParkingForm.validateFields().then(values => {
            const resetData = {
                tenant_parking_id: id,
                business_address: values.business_address || '',
                business_name: values.business_name || '',
                business_nature: values.business_nature || '',
                contact_no: values.contact_no || '',
                remarks: values.remarks || '',
                renter_email: values.renter_email || '',
                tin: values.tin || '',
                trade_name: values.trade_name || '',
            };

            const file = attachmentsData.map((data) => {
                if(data.originFileObj){
                  return data.originFileObj;
                }
                return data
            });
    
            const attch_ids = attachmentsData.map((data) => {
                if(data.id){
                    return data.id;
                }
                return ""
            });
            
        
            var finalValues = Object.entries({
                ...resetData, 
                attachments: file,
                attachment_ids: attch_ids
            }).map(([key, value]) => ({
                key,
                value,
            }));

            callPost(
                "tenant_parkings/update", 
                finalValues,
                true,
            );
        }).catch(errorInfo => {
          toast.error('Validation Failed:', errorInfo);
        });
    };

    const handleDeleteAttachment = (file) => {
        const updatedAttachments = attachmentsData.filter(item => item !== file);
        setAttachmentsData(updatedAttachments);
    };

    const normFile = (e) => {

        if (Array.isArray(e)) {
            setAttachmentsData(e)
        }
        setAttachmentsData(e?.fileList)
        
    };

    const validateContactNumber = (_, value) => {
        if (!value) {
          return Promise.resolve();
        }
    
        const isNumber = /^\d+$/.test(value);
        if (!isNumber) {
          return Promise.reject('Invalid Contact Number');
        }
        return Promise.resolve();
    };

    const onLeaseType = (value, type) => {
        if(type === "parking"){
            if (value) {
                setLeaseType({
                    parking: value
                })
                if(value === "month"){
                    addParkingForm.setFieldsValue({
                        parking_contract_date: [
                            dayjs(startParkingContractData.start_date, 'YYYY/MM/DD'),
                            dayjs(startParkingContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.parking, value)
                        ]
                    });
                    setContractDate([
                        dayjs(startParkingContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startParkingContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.parking, value)
                    ])
                } else {
                    addParkingForm.setFieldsValue({
                        parking_contract_date: [
                            dayjs(startParkingContractData.start_date, 'YYYY/MM/DD'),
                            dayjs(startParkingContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.parking, value)
                        ]
                    });
                    setContractDate([
                        dayjs(startParkingContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startParkingContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.parking, value)
                    ])
                }
            }
        } else {
            if (value) {
                setLeaseType({
                    unit: value
                })
                if(value === "month"){
                    addParkingForm.setFieldsValue({
                        contract_date: [
                            dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                            dayjs(startContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.unit, value)
                        ]
                    });
                    setContractDate([
                        dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.unit, value)
                    ])
                } else {
                    addParkingForm.setFieldsValue({
                        contract_date: [
                            dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                            dayjs(startContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.unit, value)
                        ]
                    });
                    setContractDate([
                        dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.unit, value)
                    ])
                }
            }
        }
    }

    const onLeaseChange = (value, type) => {
        if(type === 'parking') {
            if (value) {
                setLeaseTerm({
                    parking: value
                });
                if(leaseType.parking === "month"){
                    addParkingForm.setFieldsValue({
                        parking_contract_date: [
                            dayjs(startParkingContractData.start_date, 'YYYY/MM/DD'),
                            dayjs(startParkingContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(value, leaseType.parking)
                        ]
                    });
                    setContractDate([
                        dayjs(startParkingContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startParkingContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(value, leaseType.parking)
                    ])
                } else {
                    addParkingForm.setFieldsValue({
                        parking_contract_date: [
                            dayjs(startParkingContractData.start_date, 'YYYY/MM/DD'),
                            dayjs(startParkingContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(value, leaseType.parking)
                        ]
                    });
                    setContractDate([
                        dayjs(startParkingContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startParkingContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(value, leaseType.parking)
                    ])
                }
            }
        } else {
            if (value) {
                setLeaseTerm({
                    unit: value
                });                
                if(leaseType.unit === "month"){
                    addParkingForm.setFieldsValue({
                        contract_date: [
                            dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                            dayjs(startContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(value, leaseType.unit)
                        ]
                    });
                    setContractDate([
                        dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(value, leaseType.unit)
                    ])
                } else {
                    addParkingForm.setFieldsValue({
                        contract_date: [
                            dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                            dayjs(startContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(value, leaseType.unit)
                        ]
                    });
                    setContractDate([
                        dayjs(startContractData.start_date, 'YYYY/MM/DD'),
                        dayjs(startContractData.start_date, 'YYYY/MM/DD').subtract(1, 'day').add(value, leaseType.unit)
                    ])
                }
            }
        }
    }

    const handleRangeChange = (dates, type) => {
        if(type === 'parking'){
            if (dates && dates.length > 0) {
                addParkingForm.setFieldsValue({
                    parking_contract_date: [
                        dayjs(dates[0], 'YYYY/MM/DD'),
                        dayjs(dates[0], 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.parking, leaseType.parking)
                    ]
                });
                setParkingStartContractDate(() => ({
                    start_date: dates[0]
                }))
                setContractDate([
                    dayjs(dates[0], 'YYYY/MM/DD'),
                    dayjs(dates[0], 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.parking, leaseType.parking)
                ])
            }
        } else {
            if (dates && dates.length > 0) {
                addParkingForm.setFieldsValue({
                    contract_date: [
                        dayjs(dates[0], 'YYYY/MM/DD'),
                        dayjs(dates[0], 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.unit, leaseType.unit)
                    ]
                });
                setStartContractDate(() => ({
                    start_date: dates[0]
                }))
                setContractDate([
                    dayjs(dates[0], 'YYYY/MM/DD'),
                    dayjs(dates[0], 'YYYY/MM/DD').subtract(1, 'day').add(leaseTerm.unit, leaseType.unit)
                ])
            }
        }
    };
    
    const showSaveConfirm = () => {
        if(type === 'add'){
            confirm({
                title: 'Please review Lease Term and Contract Date',
                icon: <ExclamationCircleFilled style={{ color: 'yellow' }}/>,
                content: (
                  <div>
                    <div>Lease Term: {leaseTerm.unit} {leaseType.unit}</div>
                    <div>Contract Date: {formatDate(contractDate[0].format("YYYY-MM-DD"))} - {formatDate(contractDate[1].format("YYYY-MM-DD"))}</div>
                  </div>
                ),
                okText: 'Yes',
                cancelText: 'No',
                className: 'custom-modal',
                confirmLoading: loading,
                onOk() {
                  handleAddTenant()
                },
              });
        } else {
            handleEditTenant()
        }
       
    };

    const onParkingCheckedValues = (value, name) => {
        setParkingPayables((prev) => ({
          ...prev,
          [name]: value
        }))
    };

    const fetchOptions = (value) => {
        const data = tenantData
        return data
            .filter(item => item.trade_name.toLowerCase().includes(value.toLowerCase()))
            .map(item => ({ value: item.trade_name }));
    };

    const handleonSearch = (value) => {
        const fetchedOptions = fetchOptions(value);
        setOptions(fetchedOptions);
    };
    const handleOnSelect = (value) => {
        const item = tenantData.find(option => option.trade_name === value);
        setRenterId(item.renter_id);
    };
    return (
        <Layout className='page'>
            <Navbar/>
            <Layout className='content-container overflow-y'>
                <Row>
                    <Col span={24} className='header-container p-4'>
                        {type === "add" ? 'ADD' : 'EDIT'} PARKING
                    </Col>
                </Row>
                <Row>
                    <Col span={24} className='p-3'>
                        <Form form={addParkingForm} initialValues={{ lease_type: leaseType.unit, parking_lease_type: leaseType.parking }} layout="vertical" scrollToFirstError={true}>
                            <Divider className='divider-text'>Renter Information</Divider>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={8}>
                                    <Item
                                        label="Name"
                                        name="trade_name"
                                        rules={[{ required: true, message: 'Please enter your Name!' }]}
                                    >
                                        <AutoComplete
                                            options={options}
                                            onSearch={handleonSearch}
                                            onSelect={handleOnSelect}
                                            placeholder="Type to search"
                                            disabled={type === "add" ? false : true}
                                        >
                                        <Input/>
                                        </AutoComplete>
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Business Name"
                                        name="business_name"
                                        // rules={[{ required: true, message: 'Please enter your confirm Business Name!' }]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Address"
                                        name="business_address"
                                        rules={[{ required: true, message: 'Please enter your confirm Business Address!' }]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={8}>
                                    <Item
                                        label="TIN Number"
                                        name="tin"
                                        // rules={[{ required: true, message: 'Please enter your Tin!' }]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Renter Email"
                                        name="renter_email"
                                        rules={[
                                            { required: true, message: 'Please enter your email address!' },
                                            { type: 'email', message: 'Please enter a valid email address!' }
                                        ]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                                <Col span={8}>
                                    <Item
                                        label="Contact Number"
                                        name="contact_no"
                                        rules={
                                            [
                                                { 
                                                    required: true, message: 'Please enter your Contact Number!' 
                                                },
                                                {
                                                    validator: validateContactNumber
                                                },
                                            ]
                                        }
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={12}>
                                    <Item
                                        label="Nature of Renter"
                                        name="business_nature"
                                        // rules={[{ required: true, message: 'Please enter your confirm Contact Person!' }]}
                                    >
                                        <TextArea rows={3}/>
                                    </Item>
                                </Col>
                                <Col span={12}>
                                    <Item
                                        label="Remarks"
                                        name="remarks"
                                    >
                                        <TextArea rows={3}/>
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={4}>
                                    <Item
                                        label="Lease Type"
                                        name="parking_lease_type"
                                        rules={[{ required: true, message: 'Please select your Lease Type' }]} // Adjusted message
                                    >
                                        <Select 
                                            placeholder="Select a Lease Type" 
                                            disabled={type === "add" ? false : true} 
                                            onChange={(e) => onLeaseType(e, 'parking')}
                                            defaultValue={leaseType.parking} 
                                        >
                                            <Option key='month' value='month'>Monthly</Option>
                                            <Option key='year' value='year'>Yearly</Option>
                                        </Select>
                                    </Item>
                                </Col>
                                <Col span={4}>
                                    <Item
                                        label="Lease Term"
                                        name="parking_lease_term"
                                        rules={[{ required: true, message: 'Please enter your Lease Term!' }]}
                                    >
                                        <InputNumber 
                                            disabled={type === "add" ? false : true} 
                                            min={0}
                                            style={{width:'100%'}}
                                            onChange={(e) => onLeaseChange(e, 'parking')}
                                        />
                                    </Item>
                                </Col>
                               
                                <Col span={8}>
                                    <Form.Item 
                                        name="parking_contract_date"  
                                        label="Contract Date"
                                        rules={[{ required: true, message: 'Please enter your Signed Contract Date!' }]}
                                    >
                                        <RangePicker  
                                            style={{width:'100%'}}
                                            disabled={
                                                type === "edit" ? true 
                                                : 
                                                leaseTerm.parking ? 
                                                    [false, true] 
                                                    : 
                                                    true
                                            }
                                            onChange={(e) => handleRangeChange(e, 'parking')}
                                            allowClear={false}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        
                            <Divider className='divider-text mt-5'>Parking Detail</Divider>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width mb-4'>
                                <Col span={24} align='right'>
                                    <span> 
                                        {
                                            type === 'add' && (
                                                <Checkbox
                                                    onChange={(e) => onParkingCheckedValues(e.target.checked,'with_parking_security_deposit')}
                                                >Has Security Deposit?</Checkbox>
                                            )
                                        }
                                    </span> 
                                    <span> 
                                        {
                                            type === 'add' && (
                                                <Checkbox
                                                    onChange={(e) => onParkingCheckedValues(e.target.checked,'with_parking_advance_rental')}
                                                >Has Advance Rental?</Checkbox>
                                            )
                                        }
                                    </span>
                                </Col>  
                            </Row>
                                {
                                    parkingRow.map((data, index) => {
                                        return(
                                            <div
                                                className='parking-list'
                                            >
                                                <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                                    <Col span={4}>
                                                        <div>
                                                            Property/Building<span className='tenants-terminated'>*</span>
                                                        </div>
                                                        <Select 
                                                            disabled={type === "add" ? false : true}
                                                            style={{width:'100%'}}
                                                            placeholder="Select a property" 
                                                            value={data.property_id}
                                                            onChange={(e) => handleParkingUnit(e, index, 'property_id')}
                                                            showSearch
                                                            filterOption={(input, option) =>
                                                                option?.children?.toLowerCase().includes(input.toLowerCase())
                                                            }
                                                        >
                                                            {propertyParkingData?.map((option) => (
                                                                <Option key={option.id} value={option.id}>{option.name}</Option>
                                                            ))}
                                                        </Select>
                                                    </Col>
                                                    <Col span={4}>
                                                        <div>
                                                            Parking Unit<span className='tenants-terminated'>*</span>
                                                        </div>
                                                        {
                                                            type === 'add' ? (
                                                                <Select 
                                                                    disabled={type === "add" ? false : true}
                                                                    style={{width:'100%'}}
                                                                    value={data.parking_unit_ids}
                                                                    placeholder="Select a Parking Unit" 
                                                                    onChange={(e) => handleParkingUnit(e, index, 'parking_unit_ids',data.parking_list)}
                                                                    showSearch
                                                                    filterOption={(input, option) =>
                                                                        option?.children?.toLowerCase().includes(input.toLowerCase())
                                                                    }
                                                                >
                                                                    {data.parking_list?.map((option) => (
                                                                        <Option key={option.id} value={option.id}>{option.name}</Option>
                                                                    ))}
                                                                </Select>
                                                            ) : (
                                                                <Input
                                                                    disabled={true} 
                                                                    value={data.parking_unit_name}
                                                                />
                                                            )
                                                        }
                                                    </Col>
                                                    <Col span={3}>
                                                        <div>
                                                            Parking Rate<span className='tenants-terminated'>*</span>
                                                        </div>
                                                        <InputNumber
                                                            disabled={type === "add" ? false : true} 
                                                            onChange={(e) => handleParkingUnit(e, index, 'parking_rental_rates', data.parking_list, data)}
                                                            value={data.parking_rental_rates}
                                                            style={{width:'100%'}} 
                                                        />
                                                    </Col>
                                                    <Col span={3}>
                                                        <div>
                                                            Security Deposit
                                                        </div>
                                                        <InputNumber
                                                            disabled={type === "edit" ? true : parkingPayables.with_parking_security_deposit ? false : true} 
                                                            onChange={(e) => handleParkingUnit(e, index, 'parking_security_deposit_amount')}
                                                            value={type === "edit" ? data.security_deposit : parkingPayables.with_parking_security_deposit ? data.parking_security_deposit_amount : 0}
                                                            style={{width:'100%'}} 
                                                        />
                                                    </Col>
                                                    <Col span={3}>
                                                        <div>
                                                            Advance Rental
                                                        </div>
                                                        <InputNumber
                                                            disabled
                                                            onChange={(e) => handleParkingUnit(e, index, 'parking_advance_rental_amount')}
                                                            value={type === "edit" ? data.advance_rental : parkingPayables.with_parking_advance_rental ? formatAmount(data.parking_advance_rental_amount) : 0}
                                                            style={{width:'100%'}} 
                                                        />
                                                    </Col>
                                                    <Col span={2}>
                                                        <div>
                                                            Months
                                                        </div>
                                                        <InputNumber
                                                            disabled={type === "edit" ? true : parkingPayables.with_parking_advance_rental ? false : true} 
                                                            onChange={(e) => handleParkingUnit(e, index, 'parking_advance_rental_months', data.parking_list, data)}
                                                            value={type === "edit" ? data.advance_rental_month : parkingPayables.with_parking_advance_rental ? data.parking_advance_rental_months : 0}
                                                            style={{width:'100%'}}
                                                            max={leaseType.parking === 'year' ? parseInt(leaseTerm.parking) * 12 : parseInt(leaseTerm.parking)}
                                                        />
                                                    </Col>
                                                    <Col span={3} className='center'>
                                                        <Switch
                                                            checked={data.is_managed}
                                                            checkedChildren="Manage"
                                                            unCheckedChildren="Not Manage"
                                                            size='medium'
                                                            disabled={type === 'edit'}
                                                            style={{ backgroundColor: data.is_managed ? 'green' : '#0e3282' }} // Adjust the colors as needed
                                                            onChange={(e) => handleParkingUnit(e, index, 'is_managed')}
                                                        />
                                                    </Col>
                                                    <Col span={2} align='center'>
                                                        {
                                                            type === 'add' && parkingRow.length > 1 && (
                                                                <Button
                                                                    icon={<DeleteOutlined />}
                                                                    disabled={type === "edit"}
                                                                    onClick={() => handleDeleteRow(index)}
                                                                    type="link"
                                                                    size='large'
                                                                    danger
                                                                />
                                                            )
                                                        }
                                                    </Col>
                                                </Row>
                                                {
                                                    data.is_managed ?
                                                    (
                                                        <Row  className='responsive-inline responsive-width mt-2 mb-4'>
                                                            <Col span={6}>
                                                                <div>
                                                                    Management Fee
                                                                </div>
                                                                <Space>
                                                                    <InputNumber
                                                                        onChange={(e) => handleParkingUnit(e, index, 'management_fee')}
                                                                        value={data.management_fee}
                                                                        style={{width:'100%'}} 
                                                                        disabled={type === 'edit'}
                                                                    />
                                                                    <Switch
                                                                        checked={data.manage_type}
                                                                        checkedChildren="Percentage"
                                                                        unCheckedChildren="Fixed Price"
                                                                        size='medium'
                                                                        disabled={type === 'edit'}
                                                                        style={{ backgroundColor: data.manage_type ? 'green' : '#0e3282' }} // Adjust the colors as needed
                                                                        onChange={(e) => handleParkingUnit(e, index, 'manage_type')}
                                                                    />
                                                                </Space>
                                                            </Col>
                                                            <Col span={4}>
                                                                <div>
                                                                    Agent Fee
                                                                </div>
                                                                <InputNumber
                                                                    onChange={(e) => handleParkingUnit(e, index, 'agent_fee')}
                                                                    value={data.agent_fee}
                                                                    style={{width:'100%'}} 
                                                                    disabled={type === 'edit'}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    ) : (
                                                        <Row  className='responsive-inline responsive-width mt-2 mb-4'>
                                                            <Col span={4}>
                                                                <Space>
                                                                    Agent Fee
                                                                </Space>
                                                                <InputNumber
                                                                    onChange={(e) => handleParkingUnit(e, index, 'agent_fee')}
                                                                    value={data.agent_fee}
                                                                    style={{width:'100%'}} 
                                                                    disabled={type === 'edit'}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    )
                                                }
                                                
                                            </div>
                                        )
                                    })
                                }
                            <Row>
                                <Col span={12} className='my-4'>
                                    <Button
                                        type='primary'
                                        disabled={type === "add" ? false : true} 
                                        className='button-color btn-header'
                                        onClick={handleAddRow}
                                    >
                                        + Add Row
                                    </Button>
                                </Col>  
                                {
                                    parkingRow.length === 0 && (
                                        <Col span={12} className='mt-4 tenants-terminated'>
                                            *The Parking Details is Required
                                        </Col> 
                                    )
                                } 
                            </Row>
                        
                            <Row className='responsive-inline responsive-width mb-5 pb-5'>
                                <Col span={24} className='p-2'>
                                    <Item 
                                        label="Attachment"
                                        name="attachments" 
                                        // valuePropName="fileList" 
                                        getValueFromEvent={normFile} 
                                        noStyle
                                        >
                                        <Upload.Dragger 
                                            // disabled
                                            multiple
                                            name="files" 
                                            // action="/upload.do"
                                            fileList={attachmentsData}               
                                            beforeUpload={() => false}
                                            onRemove={handleDeleteAttachment}
                                        >
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                        <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                                        </Upload.Dragger>
                                    </Item>
                                </Col>
                            </Row>
                            {
                                type === "edit" && (
                                    <Row className=' mb-5'>
                                        <Col span={24} className=''>
                                            <Table 
                                                columns={columns2} 
                                                dataSource={newAttachment} 
                                                pagination={false}
                                                loading={{
                                                indicator: customSpinner, // Use custom spinner
                                                spinning: isLoading, // Set spinning based on loading state
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                )
                            }
                            <Row className='btn-footer'>
                                <Space className='p-2'>
                                    <Button
                                        onClick={() => navigate('/parking-contract')}
                                        className='cancel-color btn-header'
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        onClick={showSaveConfirm}
                                        loading={loading}
                                        type='primary'
                                        className='button-color btn-header'
                                        disabled={handleSaveValidation()}
                                    >
                                        {type === 'add' ? 'Submit' : 'Save'}
                                    </Button>
                                </Space>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Layout>
        </Layout>
    )
}

export default AddEditContract
